export default __webpack_public_path__ + "static/media/home-go.67c09fc3.png";